module.exports = " <div class=btn :class=buttonClass :data-direction=direction _v-3a4b54f8=\"\"> <div class=btn-back _v-3a4b54f8=\"\"> <p _v-3a4b54f8=\"\">Are you sure you want to do that?</p> <button class=yes @click=confirm _v-3a4b54f8=\"\">Yes</button> <button class=no @click=hide _v-3a4b54f8=\"\">No</button> </div> <div class=btn-front @click=click _v-3a4b54f8=\"\">Delete</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3a4b54f8!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/FlipButton.vue
// module id = 743
// module chunks = 2